export default "__VITE_ASSET__Dk9J9tbS__"